import React from 'react';
import { Box, Text, TextInput } from '@televet/kibble-ui';
import { email } from 'shared/utils/validation';

interface IReceiptInputProps {
  receiptEmail: string | undefined;
  handleChangeReceiptEmail: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setValidationMessage: (value: React.SetStateAction<string>) => void;
}

const ReceiptInput = ({
  receiptEmail,
  handleChangeReceiptEmail,
  setValidationMessage,
}: IReceiptInputProps): JSX.Element => {
  return (
    <Box mt="0" className="Payment__Wrapper-Receipt-Email-Input">
      <Box mt="0" className="Payment__Label-Wrapper-Receipt-Email-Input" pb="2">
        <Text size="sm">Receipt Email</Text>
      </Box>
      <TextInput
        className="Payment__Receipt-Email-Input"
        defaultValue={receiptEmail || ''}
        placeholder={receiptEmail || 'Enter email address'}
        style={{ padding: '0 16px' }}
        onChange={handleChangeReceiptEmail}
        // check if input is valid email by using regex
        onBlur={(): void => {
          if (receiptEmail && !email.test(receiptEmail)) {
            setValidationMessage('Please enter a valid email address');
          } else {
            setValidationMessage('');
          }
        }}
      />
    </Box>
  );
};

export default ReceiptInput;
